<script setup lang="ts">
import { computed } from 'vue';
import ResourceDialogQualificationStatus from './ResourceDialogQualificationStatus.vue';
import { useQualificationsQuery } from '/@entities/qualification/api/useQualificationsQuery';
import { Resource } from '/@types/resources';

const props = defineProps<{
  resource: Resource;
}>();

const { data: qualifications } = useQualificationsQuery();

const filteredQualifications = computed(() =>
  props.resource.qualifications
    ? [...new Map(props.resource.qualifications.map((x) => [x.id, x])).values()]
        .filter((x) => qualifications.value?.some((y) => y.Id === x.id && y.IsAvailableInResource))
        .sort((a, b) => a.name.localeCompare(b.name, 'nb-no'))
    : [],
);
</script>

<template>
  <div v-if="filteredQualifications.length > 0" class="dl__group dl__group--large">
    <dt class="dl__topic">Kompetanser</dt>
    <dd class="dl__description">
      <ul class="list">
        <li
          v-for="qualification in filteredQualifications"
          :key="qualification.id"
          class="list__item"
        >
          <div class="info">
            <span>{{ qualification.name }}</span>
            <ResourceDialogQualificationStatus :status-id="qualification.statusId" />
          </div>
        </li>
      </ul>
    </dd>
  </div>
</template>

<style scoped>
.list__item {
  margin: var(--gap-sm) 0;
}

.info {
  display: flex;
  gap: var(--gap-md);
}
</style>
